// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"508":"7c68397c","655":"50c53d68"}[chunkId] + ".chunk.js";
};